module.exports = __webpack_public_path__ + "img/avatar.5a76bb91.png";